export const EXPERIMENTS = {
  product_default_quantity: {
    id: "BjhXFwbHRSizrqNVyJcB_g",
    variations: {
      "0": 1,
      "1": 5,
    }
  }
} as const
